import { track } from '@amplitude/analytics-browser'

/** Sends an Amplitude event; a tracking error never breaks the page. */
const safeTrack = (event, props) => {
  try {
    track(event, props)
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}

export default safeTrack
